import ActionsForm from '@/shared/mixins/actionsForm'
import qmaTemplateMetadataType from '@/shared/http/repositories/business/qmaTemplateMetadataType'
import { toast, loading } from '@/shared/utils/UIHelper'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'addquestion',
  props: ['preRequisito', 'etapaId', 'pergunta', 'perguntaId', 'grupoId', 'etapaCriada', 'metadado', 'equipamento'],
  components: {},
  mixins: [ActionsForm],
  data () {
    return {
      novoItemTipo: null,
      edicaoPerguntas: false,
      EscolherTipoPergunta: true,
      novoPergunta: null,
      nivelPrioridade: null,
      formattedValue: null,
      subExistente: false,
      tipoCampo: [],
      opcaoImagemLocal: [],
      opcaoTextoLocal: [],
      nameFile: null,
      descricaoImagem: null,
      file: null,
      file64: null,
      galeria: false,
      multiplo: false,
      valorDecimal: null,
      respostaObrigatoria: true,
      editarImagem: false,
      base64ImagemPopUp: null,
      descricaoImagemPopUp: null,
      arquivoIdImagemPopUp: null,
      perguntaSelecao: null,
      UltimoNivel: null,
      perguntaSelecaoId: null,
      novaImagem: false
    }
  },
  mounted () {
    if (this.preRequisito === true) {
      this.EscolherTipoPergunta = false
    }
    this.statusTipoCampo()
  },
  watch: {
    perguntaSelecao (value) {
      if (value != null) {
        if (value.trim() !== '') {
          this.CorButtonVerde()
        } else {
          this.CorButtonCinza()
        }
      }
    },
    formattedValue (newValue) {
      if (!newValue) {
        this.formattedValue = 0
        this.formattedValue = ''
        return
      }
      let valor = String(newValue)

      // Se tiver ponto decimal e apenas 1 dígito depois, adiciona um 0
      if (valor.includes('.')) {
        let [inteiro, decimal] = valor.split('.')
        if (decimal.length === 1) {
          this.valorDecimal = `${inteiro}.${decimal}0`
        }
      }

      // Converte para string antes de usar replace
      let rawValue = String(this.valorDecimal === null ? newValue : this.valorDecimal).replace(/\D/g, '')

      if (!rawValue) {
        this.$nextTick(() => {
          this.nivelPrioridade = 0
          this.formattedValue = ''
        })
        return
      }

      let number = parseFloat(rawValue) / 100 // Converte para decimal real
      this.valorDecimal = null
      // Guarda o número puro para cálculos
      this.nivelPrioridade = number
      this.$nextTick(() => {
        this.formattedValue = number.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).replace(',', '.')
      })
    }
  },
  methods: {
    focarDescricao () {
      this.$refs.descricaoTextarea.focus()
    },
    CorButtonVerde () {
      var div = document.getElementById('campoAddSelecaoTexto')
      div.classList.add('clicked')
    },
    CorButtonCinza () {
      var div = document.getElementById('campoAddSelecaoTexto')
      div.classList.remove('clicked')
    },
    popUptAddPergunta (pergunta, tipo, adicao, itemImagem, multiplos, opcional, nivel, ultimoNivel, edicao) {
      this.edicaoPerguntas = edicao
      this.galeria = false
      this.UltimoNivel = ultimoNivel
      // `opcional` chega no sentido do banco (true = NAO obrigatorio). A tela pergunta
      // "Resposta obrigatoria?", entao a inversao acontece aqui — e so aqui.
      this.respostaObrigatoria = opcional == null ? true : !opcional
      this.multiplo = multiplos === undefined || multiplos === null ? false : multiplos
      this.opcaoImagemLocal = itemImagem === undefined || itemImagem === null ? [] : itemImagem
      this.opcaoTextoLocal = itemImagem === undefined || itemImagem === null ? [] : itemImagem
      this.file64 = null
      this.file = null
      this.formattedValue = nivel === undefined || nivel === null ? null : nivel
      if (edicao === false) {
        this.formattedValue = ultimoNivel === undefined || ultimoNivel === null ? null : ultimoNivel
      }
      this.novoPergunta = pergunta
      this.novoItemTipo = tipo
      if (this.preRequisito === true) {
        this.subExistente = false
      } else {
        this.subExistente = !adicao
      }
      this.$refs['add-nova-pergunta'].show()
    },
    fecharPopUptAdd () {
      this.$refs['add-nova-pergunta'].hide()
    },
    adicionarPergunta () {
      loading.push()
      this.novoPergunta = this.novoPergunta !== null && this.novoPergunta !== undefined ? this.novoPergunta.trim() : this.novoPergunta
      if (this.novoPergunta == null || this.novoPergunta === '') {
        loading.pop()
        return toast.warning('Insira a descrição do campo')
      }
      if (this.preRequisito === false && this.metadado === true) {
        if (this.novoItemTipo == null || this.novoItemTipo === undefined) {
          loading.pop()
          return toast.warning('Insira o tipo do campo')
        }
      }
      let pergunta = {
        check: false,
        colorStatus: 'rgb(212, 238, 253)',
        colorFonte: 'rgb(0, 55, 137)',
        descricaoEdicao: 'AG. ENVIO NOVO ITEM',
        edicao: true,
        adicao: true,
        multiplos: this.multiplo,
        exclusaoEtapa: false,
        opcional: !this.respostaObrigatoria,
        descricaoPergunta: this.novoPergunta.toUpperCase(),
        itensSelecaoImagem: this.opcaoImagemLocal.length === 0 ? this.opcaoTextoLocal : this.opcaoImagemLocal,
        perguntaId: uuidv4(),
        nivelPrioridadePergunta: this.nivelPrioridade === null ? this.UltimoNivel : this.nivelPrioridade,
        tipoCampo: this.novoItemTipo
      }
      let etapa = {
        etapaId: this.etapaId,
        pergunta: pergunta
      }

      let add = {
        etapaId: this.etapaId,
        pergunta: this.novoPergunta.toUpperCase(),
        perguntaId: pergunta.perguntaId,
        temporarioId: uuidv4(),
        perguntaSelecao: this.opcaoTextoLocal,
        nivelPrioridadePergunta: this.nivelPrioridade === null ? this.UltimoNivel : this.nivelPrioridade,
        opcional: !this.respostaObrigatoria,
        multiplos: this.multiplo
      }

      this.colocarIdTemporario(add.temporarioId)

      if (this.grupoId != null) {
        add = {
          etapaId: this.grupoId,
          subEtapaId: this.etapaId,
          pergunta: this.novoPergunta.toUpperCase(),
          temporarioId: uuidv4(),
          nivelPrioridadePergunta: this.nivelPrioridade === null ? this.UltimoNivel : this.nivelPrioridade,
          perguntaSelecao: this.opcaoTextoLocal,
          perguntaId: pergunta.perguntaId,
          opcional: !this.respostaObrigatoria,
          tipoCampo: this.novoItemTipo,
          multiplos: this.multiplo
        }
        this.colocarIdTemporario(add.temporarioId)
        this.$emit('addNovaPerguntaImagem', this.opcaoImagemLocal)

        this.$emit('addNovaPerguntaGrupo', add)
      }
      if (this.etapaCriada === false && this.subExistente === false) {
        this.$emit('addNovaPergunta', add)
      } if (this.etapaCriada === true && this.subExistente === false) {
        this.$emit('addNovaPerguntaParaSubEtapa', add)
      } else if (this.subExistente === true) {
        this.$emit('addNovaPerguntaEtapaSubCriada', add)
      } else {
        this.$emit('addNovaPergunta', add)
      }
      this.$emit('tabelaNovaPergunta', etapa)
      this.fecharPopUptAdd()
      loading.pop()
    },
    editarPergunta () {
      this.novoPergunta = this.novoPergunta.trim()
      let etapa = {
        grupoId: this.grupoId,
        etapaId: this.etapaId,
        perguntaId: this.perguntaId,
        tipoCampo: this.novoItemTipo,
        subEtapaId: this.etapaId,
        perguntaSelecao: this.opcaoTextoLocal,
        nivelPrioridadePergunta: this.nivelPrioridade,
        multiplos: this.multiplo,
        opcional: !this.respostaObrigatoria,
        pergunta: this.novoPergunta.toUpperCase()
      }

      let altera = {
        etapaId: this.grupoId == null ? this.etapaId : this.grupoId,
        perguntaId: this.perguntaId,
        tipoCampo: this.novoItemTipo,
        nivelPrioridadePergunta: this.nivelPrioridade,
        multiplos: this.multiplo,
        opcional: !this.respostaObrigatoria,
        perguntaSelecao: this.opcaoTextoLocal,
        subEtapaId: this.etapaId,
        pergunta: this.novoPergunta.toUpperCase()
      }

      if (this.grupoId != null) {
        this.$emit('editarEmMemoriaNovaPerguntaParaEtapa', altera)
      }

      if (this.etapaCriada === false && this.subExistente === false) {
        this.$emit('editarNovaPerguntaParaSubEtapa', etapa)
      } else if (this.subExistente === true) {
        this.$emit('editarNovaPerguntaEtapaSubCriada', etapa)
      }
      this.$emit('EditarNovaPerguntaImagem', this.opcaoImagemLocal)

      this.$emit('editarPergunta', etapa)

      this.fecharPopUptAdd()
    },
    colocarIdTemporario (id) {
      if (this.opcaoImagemLocal !== null && this.opcaoImagemLocal !== undefined && this.opcaoImagemLocal.length > 0) {
        for (let e = 0; e < this.opcaoImagemLocal.length; e++) {
          this.opcaoImagemLocal[e].temporarioId = id
        }
      }
    },
    statusTipoCampo () {
      qmaTemplateMetadataType.GetStatusTemplateQMA()
        .then((Response) => {
          if (this.equipamento === true) {
            this.tipoCampo.push(Response.data[0], Response.data[1], Response.data[3])
          }
          if (this.equipamento !== true) {
            this.tipoCampo = Response.data
          }
        })
        .catch((Error) => {
          toast.error('dados não encontrados')
        })
    },
    openFileImg () {
      document.getElementById('impor-Img').click()
    },
    GetValueFile (e) {
      this.nameFile = e.target.files[0].name
      this.file = e.target.files[0]
      this.file64 = e.target.files[0]

      const reader = new FileReader()

      reader.readAsDataURL(this.file64)

      reader.onload = () => {
        this.file64 = reader.result
        console.log(this.file64)
      }
      reader.onerror = (error) => {
        console.error('Erro ao converter o arquivo para Base64 ', error)
      }
    },
    adicionarOpcaoImagem () {
      if (this.descricaoImagem == null || this.descricaoImagem === '') {
        return toast.warning('Insira a descrição da imagem')
      }
      if (this.editarImagem === false) {
        const formData = new FormData()
        formData.append('file', this.file)

        var imgOpcao = {
          perguntaId: this.perguntaId,
          descricaoPerguntaSelecaoImagem: this.descricaoImagem.toUpperCase(),
          adicao: true,
          edicao: false,
          exclusao: false,
          imagem: true,
          file: formData,
          file64: this.file64,
          temporarioId: null,
          arquivoId: uuidv4()
        }
        if (this.opcaoImagemLocal !== null && this.opcaoImagemLocal !== undefined && this.opcaoImagemLocal.length > 0) {
          this.opcaoImagemLocal.push(imgOpcao)
        } else {
          this.opcaoImagemLocal[0] = imgOpcao
        }
        this.file64 = null
        this.descricaoImagem = null
      }

      if (this.editarImagem === true) {
        if (this.opcaoImagemLocal !== null && this.opcaoImagemLocal !== undefined && this.opcaoImagemLocal.length > 0) {
          for (let e = 0; e < this.opcaoImagemLocal.length; e++) {
            if (this.opcaoImagemLocal[e].arquivoId === this.arquivoIdImagemPopUp) {
              const formData = new FormData()

              if (this.file !== null) {
                formData.append('file', this.file)
              }

              this.opcaoImagemLocal[e].file = formData
              this.opcaoImagemLocal[e].file64 = this.file64
              this.opcaoImagemLocal[e].descricaoPerguntaSelecaoImagem = this.descricaoImagem
              this.opcaoImagemLocal[e].edicao = true
              // var imagemEditada = {
              //   descricao: this.descricaoImagem,
              //   file: this.formData,
              //   file64: this.file64,
              //   etapaId: this.etapaId,
              //   arquivoId: this.
              // }
              // this.$emit('editarImagemNova', imagemEditada)
            }
          }
        }
        this.file64 = null
        this.descricaoImagem = null
        this.base64ImagemPopUp = null
        this.arquivoIdImagemPopUp = null
        this.descricaoImagemPopUp = null
        this.editarImagem = false
      }
    },
    irParaGaleria () {
      this.galeria = true
    },
    voltaParaMenu () {
      this.galeria = false
      this.descricaoImagem = null
      this.file64 = null
      this.file = null

      this.base64ImagemPopUp = null
      this.arquivoIdImagemPopUp = null
      this.descricaoImagemPopUp = null
      this.editarImagem = false
    },
    modal_preview_imagem (arquivo) {
      this.base64ImagemPopUp = arquivo.file64 === undefined ? 'data:image/jpeg;base64,' + arquivo.base64 : arquivo.file64
      this.arquivoIdImagemPopUp = arquivo.arquivoId
      this.descricaoImagemPopUp = arquivo.descricaoPerguntaSelecaoImagem
      this.descricaoImagem = arquivo.descricaoPerguntaSelecaoImagem
      this.perguntaSelecaoId = arquivo.perguntaSelecaoImagemId
      this.novaImagem = arquivo.adicao

      var modal = document.getElementById('preview_imagem')

      var img = document.getElementById(arquivo.arquivoId)
      var modalImg = document.getElementById('img_modal')
      var captionText = document.getElementById('caption')
      img.onclick = function () {
        modal.style.display = 'block'
        modalImg.src = this.src
        captionText.innerHTML = arquivo.descricaoPerguntaSelecaoImagem
      }
    },
    fecha_modal_preview_imagem () {
      this.base64ImagemPopUp = null
      this.arquivoIdImagemPopUp = null
      this.descricaoPerguntaSelecaoImagem = null
      this.descricaoImagem = null
      var modal = document.getElementById('preview_imagem')
      modal.style.display = 'none'
    },
    habilitar_edicao_imagem (Base64, DescricaoImagem) {
      var modal = document.getElementById('preview_imagem')
      modal.style.display = 'none'
      this.editarImagem = true
      this.galeria = false
      this.file64 = this.base64ImagemPopUp
    },
    adicionarOpcao (item) {
      loading.push()
      if (item === undefined || item == null) {
        loading.pop()
        if (this.perguntaSelecao == null || this.perguntaSelecao === '') {
          loading.pop()
          return toast.warning('Insira o texto da alternativa')
        }
        var textoOpcaoAdicao = {
          exclusao: false,
          adicao: true,
          perguntaSelecaoImagemId: null,
          tag: false,
          imagem: false,
          descricaoPerguntaSelecaoImagem: this.perguntaSelecao.toUpperCase(),
          opcaoId: uuidv4()
        }
        if (this.opcaoTextoLocal !== null && this.opcaoTextoLocal !== undefined && this.opcaoTextoLocal.length > 0) {
          this.opcaoTextoLocal.push(textoOpcaoAdicao)
        } else {
          this.opcaoTextoLocal[0] = textoOpcaoAdicao
        }
      } else {
        if (item.adicao === true) {
          loading.pop()
        } else {
          let adicaoEstado = false
          if (item === null || item === null) {
            adicaoEstado = true
          }

          let exclusaoEstado = false
          if (item !== null || item !== null) {
            exclusaoEstado = true
          }
          var textoOpcao = {
            exclusao: exclusaoEstado,
            imagem: false,
            adicao: adicaoEstado,
            perguntaSelecaoImagemId: item === undefined || item == null ? null : item.perguntaSelecaoImagemId,
            tag: exclusaoEstado,
            descricaoPerguntaSelecaoImagem: item === undefined || item == null ? this.perguntaSelecao : item.descricaoPerguntaSelecaoImagem.toUpperCase(),
            opcaoId: uuidv4()
          }
          if (this.opcaoTextoLocal !== null && this.opcaoTextoLocal !== undefined && this.opcaoTextoLocal.length > 0) {
            this.opcaoTextoLocal.push(textoOpcao)
          } else {
            this.opcaoTextoLocal[0] = textoOpcao
          }
        }
      }

      loading.pop()
      this.perguntaSelecao = null
      this.CorButtonCinza()
    },
    removerOpcoesTexto (item) {
      if (this.opcaoTextoLocal !== null && this.opcaoTextoLocal !== undefined && this.opcaoTextoLocal.length > 0) {
        for (let e = 0; e < this.opcaoTextoLocal.length; e++) {
          if (this.opcaoTextoLocal[e].opcaoId === item.opcaoId) {
            this.opcaoTextoLocal.splice(e, 1)
            this.adicionarOpcao(item)
            e--
            break
          }
        }
      }
    },
    removerOpcoesImagem () {
      if (this.opcaoImagemLocal !== null && this.opcaoImagemLocal !== undefined && this.opcaoImagemLocal.length > 0) {
        for (let e = 0; e < this.opcaoImagemLocal.length; e++) {
          if (this.opcaoImagemLocal[e].arquivoId === this.arquivoIdImagemPopUp && this.opcaoImagemLocal[e].adicao === false) {
            this.opcaoImagemLocal[e].exclusao = true
            this.opcaoImagemLocal[e].edicao = true
            this.file64 = null
            this.descricaoImagem = null
            this.base64ImagemPopUp = null
            this.arquivoIdImagemPopUp = null
            this.descricaoImagemPopUp = null
            this.editarImagem = false
            var excluirImagem = {
              perguntaSelecaoImagemId: this.opcaoImagemLocal[e].perguntaSelecaoImagemId,
              perguntaId: this.perguntaId,
              etapaId: this.etapaId
            }

            this.$emit('excluirImagem', excluirImagem)
            break
          }
          if (this.opcaoImagemLocal[e].arquivoId === this.arquivoIdImagemPopUp && this.opcaoImagemLocal[e].adicao === true) {
            this.opcaoTextoLocal.splice(e, 1)
            this.file64 = null
            this.descricaoImagem = null
            this.base64ImagemPopUp = null
            this.arquivoIdImagemPopUp = null
            this.descricaoImagemPopUp = null
            this.$emit('removerImagemNova', this.opcaoImagemLocal[e].arquivoId)
            e--
            break
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/SubGroupDetail/addquestion/addquestion.js